import { PropsWithChildren, createContext, useContext, useState } from 'react';

const defaultValuesAuditContext = {
  auditEntryId: null,
};

type AuditContextType = {
  auditEntryId: string | null;
  setAuditEntryId?: (auditEntryId: string | null) => void;
};

export const AuditContext = createContext<AuditContextType>(
  defaultValuesAuditContext,
);

export const useAuditContext = () => useContext(AuditContext);

export const AuditProvider = ({ children }: PropsWithChildren) => {
  const [auditEntryId, setAuditEntryId] = useState(null);

  return (
    <AuditContext.Provider
      value={{
        auditEntryId,
        setAuditEntryId,
      }}
    >
      {children}
    </AuditContext.Provider>
  );
};
